import { motion } from "framer-motion";

/**
 * DARK BAND A — Value proposition. Kinetic word reveal on scroll.
 */
export default function ValueProp() {
  return (
    <section
      data-testid="value-prop"
      className="rl-dark-band py-16 md:py-24"
      aria-label="Value proposition"
    >
      <span className="rl-dark-band__grid" aria-hidden />
      <span
        className="rl-dark-band__blob"
        aria-hidden
        style={{ width: 640, height: 640, top: -160, left: -180, background: "#5B2A86" }}
      />
      <span
        className="rl-dark-band__blob"
        aria-hidden
        style={{ width: 560, height: 560, bottom: -140, right: -160, background: "#F5B841", animationDelay: "8s" }}
      />

      <div className="rl-dark-band__inner mx-auto max-w-[1280px] px-6 md:px-10 grid md:grid-cols-12 gap-8 md:gap-12">
        <div className="md:col-span-4">
          <div className="font-editorial-mono text-[10.5px] text-[#F5B841] mb-4">
            EXPERTISE ACROSS DOMAINS
          </div>
          <motion.h2
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.85, ease: [0.22, 1, 0.36, 1] }}
            className="font-editorial-display text-[#F5F5F7] leading-[1.02] tracking-[-0.02em]"
            style={{ fontSize: "clamp(36px, 4.4vw, 60px)", letterSpacing: "0.01em" }}
          >
            End-to-end
            <br />
            <span className="font-editorial-italic text-[#F5B841]">cybersecurity.</span>
          </motion.h2>
        </div>

        <div className="md:col-span-7 md:col-start-6">
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.85, ease: [0.22, 1, 0.36, 1] }}
            className="text-[17px] md:text-[19px] leading-[1.6] text-[#DADCE3] font-light"
            style={{ letterSpacing: "0.01em" }}
          >
            RockLadder is a next-generation managed security partner. We consult,
            implement, manage and test across your entire security landscape —
            engineered for enterprises that refuse to be tomorrow's headline.
            Built for <strong className="rl-gold rl-underline-gold">resilience</strong>,
            designed to enable <strong className="rl-gold rl-underline-gold">growth</strong>.
          </motion.p>

          <motion.ul
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, margin: "-40px" }}
            variants={{ show: { transition: { staggerChildren: 0.09 } } }}
            className="mt-10 space-y-2 md:space-y-3"
          >
            {[
              <>Security Operations <em className="not-italic text-[#8A8A8A]">·</em> Identity <em className="not-italic text-[#8A8A8A]">·</em> Endpoint Defense</>,
              <>Managed Detection <em className="not-italic text-[#8A8A8A]">·</em> Secure Access <em className="not-italic text-[#8A8A8A]">·</em> Cloud &amp; Application</>,
              <>Data Protection <em className="not-italic text-[#8A8A8A]">·</em> AI Security <em className="not-italic text-[#8A8A8A]">·</em> Risk &amp; Compliance</>,
            ].map((line, i) => (
              <motion.li
                key={i}
                variants={{
                  hidden: { opacity: 0, y: 26 },
                  show: { opacity: 1, y: 0, transition: { duration: 0.75, ease: [0.22, 1, 0.36, 1] } },
                }}
                className="font-editorial-italic text-[#F5F5F7] leading-[1.15] tracking-[-0.01em]"
                style={{ fontSize: "clamp(24px, 3.2vw, 40px)", fontStyle: "italic" }}
              >
                <span className="text-[#F5B841] font-editorial-mono text-[10.5px] not-italic align-middle mr-3">
                  /0{i + 1}
                </span>
                {line}
              </motion.li>
            ))}
          </motion.ul>
        </div>
      </div>
    </section>
  );
}
